import { render, staticRenderFns } from "./reformCatalogList.vue?vue&type=template&id=c7545e0c&scoped=true"
import script from "./reformCatalogList.vue?vue&type=script&lang=js"
export * from "./reformCatalogList.vue?vue&type=script&lang=js"
import style0 from "./reformCatalogList.vue?vue&type=style&index=0&id=c7545e0c&prod&lang=css"
import style1 from "./reformCatalogList.vue?vue&type=style&index=1&id=c7545e0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7545e0c",
  null
  
)

export default component.exports